var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsCounter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_8)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8977 0C44.3326 0 50 5.92093 50 14.7326V35.2674C50 44.0791 44.3326 50 35.8977 50H14.1023C5.66744 50 0 44.0791 0 35.2674V14.7326C0 5.92093 5.66744 0 14.1023 0H35.8977ZM35.8977 3.48837H14.1023C7.65581 3.48837 3.48837 7.9 3.48837 14.7326V35.2674C3.48837 42.1 7.65581 46.5116 14.1023 46.5116H35.8977C42.3465 46.5116 46.5116 42.1 46.5116 35.2674V14.7326C46.5116 7.9 42.3465 3.48837 35.8977 3.48837ZM14.2351 19.0756C15.1979 19.0756 15.9793 19.857 15.9793 20.8198V36.7733C15.9793 37.736 15.1979 38.5174 14.2351 38.5174C13.2723 38.5174 12.4909 37.736 12.4909 36.7733V20.8198C12.4909 19.857 13.2723 19.0756 14.2351 19.0756ZM25.0886 11.4384C26.0514 11.4384 26.8328 12.2198 26.8328 13.1826V36.7709C26.8328 37.7337 26.0514 38.5151 25.0886 38.5151C24.1258 38.5151 23.3444 37.7337 23.3444 36.7709V13.1826C23.3444 12.2198 24.1258 11.4384 25.0886 11.4384ZM35.7637 27.5058C36.7265 27.5058 37.5079 28.2872 37.5079 29.25V36.7709C37.5079 37.7337 36.7265 38.5151 35.7637 38.5151C34.8009 38.5151 34.0195 37.7337 34.0195 36.7709V29.25C34.0195 28.2872 34.8009 27.5058 35.7637 27.5058Z",
    fill: "#00BAB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsCounter3);
export default __webpack_public_path__ + "static/media/about-us-counter-3.f095c6f6a1cfb6d12209a2dccc4e80dd.svg";
export { ForwardRef as ReactComponent };